import { MailTemplate } from '@/interfaces/mailTemplate';
import { MailTemplateResource, mailTemplateResource } from '@/resources/mailTemplate.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł szablonów wiadomości e-mail
 *
 * @export
 * @class MailTemplateModule
 * @extends {EntityModule<MailTemplate, MailTemplateResource>}
 */
export class MailTemplateModule extends EntityModule<MailTemplate, MailTemplateResource> {
  constructor() {
    super(mailTemplateResource);
  }
}

export default new MailTemplateModule();
